import { forwardRef } from 'react';
import './buttonTemplate.css';

const ButtonTemplate = forwardRef(({
    click,
    background,
    cor,
    width,
    qtdColuna,
    textTransform,
    children,
    pointerEvents,
    tabIndex,
    onKeyDown,
    padding,
    fontSize,
    type = 'button',
    style,
    className
}, ref) => {

    return (
        <button
            ref={ref}
            tabIndex={tabIndex}
            className={`button-template${className ? ` ${className}` : ''}`}
            onClick={click}
            onKeyDown={onKeyDown}
            style={{
                background: background,
                color: cor,
                gridColumn: qtdColuna,
                pointerEvents: pointerEvents,
                padding: padding,
                fontSize: fontSize,
                width: width,
                textTransform: textTransform,
                ...(style || {})
            }}
            type={type}
        >
            {children}
        </button>
    );
});

export default ButtonTemplate;